import { IPaginator } from "src/types";
import React from "react";

interface IPaginatorProps {
  paginator: IPaginator;
  setCurrentPage: (v: number) => void;
}

const PaginatorBtn = ({ paginator, setCurrentPage }: IPaginatorProps) => {
  const { page, pages, limit, total } = paginator;

  const createPages = () => {
    const buttons: (number | string)[] = [];

    if (pages <= 7) {
      for (let i = 1; i <= pages; i++) buttons.push(i);
    } else {
      buttons.push(1);

      if (page > 4) buttons.push("...");

      for (
        let i = Math.max(2, page - 2);
        i <= Math.min(pages - 1, page + 2);
        i++
      ) {
        buttons.push(i);
      }

      if (page < pages - 3) buttons.push("...");

      buttons.push(pages);
    }

    return buttons;
  };

  const visiblePages = createPages();

  return (
    <div className="flex flex-col items-center gap-4 mt-8">
      {/* Pagination buttons */}
      <div className="flex justify-center items-center gap-2 flex-wrap">
        <button
          onClick={() => setCurrentPage(Math.max(1, page - 1))}
          disabled={page === 1}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-sm"
        >
          Prev
        </button>

        {visiblePages.map((p, i) => (
          <button
            key={i}
            disabled={p === "..."}
            className={`px-3 py-1 rounded text-sm ${
              page === p
                ? "bg-brand text-white"
                : p === "..."
                  ? "text-gray-500 cursor-default"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
            onClick={() => typeof p === "number" && setCurrentPage(p)}
          >
            {p}
          </button>
        ))}

        <button
          onClick={() => setCurrentPage(Math.min(pages, page + 1))}
          disabled={page === pages}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-sm"
        >
          Next
        </button>
      </div>

      <div className="text-[16px] font-medium text-gray-600">
        Page <span className="font-medium">{page}</span> of{" "}
        <span className="font-medium">{pages}</span> · Showing{" "}
        <span className="font-medium">{limit}</span> per page · Total{" "}
        <span className="font-medium">{total}</span> Assets
      </div>
    </div>
  );
};

export default PaginatorBtn;
